/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{BaseRasterColorizerShader as e}from"../BaseRasterColorizerShader.js";class r extends e{constructor(){super(...arguments),this.type="ReprojectShader"}_colorize(e){return this._getPixel(e)}}export{r as ReprojectShader};
